import { ReportEntry } from '../../types'

const report: ReportEntry[] = [
	{
		id: 1,
		name: 'foo',
		end_customers: [
			{
				id: 1,
				name: 'bar',
				licenses: [
					{
						type: 'CRM',
						quantity: 99,
						consumed: 2,
						display_name: 'CRM integration',
						serial: 'ABCXYZ123'
					}
				]
			}
		]
	}
]

export default report
